<template>
  <page no-styling>
    <div class="card slightly_yellow_background">
      <card-header
        :title="$t('cms.beacon.Title')"
        :description="$t('cms.beacon.Description')"
      >
        <template #icon>
          <icon beacons xlarge/>
        </template>
        <template #info>
          <h1>
            TODO: replace info content here
          </h1>
        </template>
      </card-header>
      <div class="mx-4 my-2">
        <loader v-if="beacons === null" class="py4"/>

        <h3 v-else-if="beacons.length === 0" class="pa4">
          No beacons found.
        </h3>

        <div v-else class="py4">
          <div
            v-for="(beacon, index) in beacons"
            :key="beacon.id"
            class="flex column px4 my2"
          >
          <beacon :value="beacon"/>

          <hr v-if="index !== beacons.length - 1" class="my4"/>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import store from '@/store';
import Beacon from '@/components/Beacon.vue';
import CardHeader from '../components/global/CardHeader.vue';
import Icon from '../components/global/Icon.vue';

export default {
  name: 'beacon-data',

  components: { Beacon, CardHeader, Icon },

  data() {
    return {
      beacons: null,
    };
  },

  created() {
    this.fetchBeaconData();
  },

  methods: {
    async fetchBeaconData() {
      const organizationId = store.state.organization.id;
      const { data, errors } = await this.$query(this.$queries.beacons, { organizationId });

      if (data.beacons) {
        this.beacons = data.beacons;
      } else {
        this.handleErrors(errors);
      }
    },
  },
};
</script>
